import axios from 'axios';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/vue';
import { COOKIE_NAME, setLoginInfo } from './login-util';

export const breakDownHostUrl = (url: string) => {
  let hostUrl = url;
  let newUrl = hostUrl;
  // 防止未做301跳转，产生XXX.XXX的域名
  if (hostUrl.split('.') && hostUrl.split('.').length <= 2) {
    newUrl = hostUrl;
  } else {
    let number = hostUrl.indexOf('.');
    newUrl = hostUrl.slice(number + 1);
  }
  return newUrl;
};

export const setRenewing = (isRenewing = true) => {
  const cookieOptions = {
    expires: 1,
    httpOnly: false,
  };
  const webDomain = breakDownHostUrl(location.hostname);

	if (!webDomain.includes('localhost')&&!(/BitMart/).test(navigator?.userAgent)) {
		Object.assign(cookieOptions, {
      domain: `.${webDomain}`,
		});
	}
  if(isRenewing) {
    Cookies.set(COOKIE_NAME.RENEWING, '1', cookieOptions);
  } else {
    Cookies.remove(COOKIE_NAME.RENEWING, cookieOptions);
    Cookies.remove(COOKIE_NAME.RENEWING);
  }
};

export const isGlobalRenewing = () => {
  return Cookies.get(COOKIE_NAME.RENEWING) === '1';
};


export const refreshToken = (req) => {
  const cookieOptions = {
    expires: 30,
    httpOnly: false,
  };
  const webDomain = breakDownHostUrl(location.hostname);

	if (!webDomain.includes('localhost')) {
		Object.assign(cookieOptions, {
      domain: `.${webDomain}`,
		});
	}

  const { headers } = req;
  /**  老的Token如果有则兼容赋值到 headers.Authorization === START ===稳定后删除 */
  const oldToken = Cookies.get(COOKIE_NAME.TOKEN);
  if (oldToken) {
    headers.Authorization = oldToken;
    // 当后端切换为单写的时候需要将老的token移除 否则老token会一直存在 「老版本token过期时间为30D」
    setTimeout(() => {
      if(Cookies.get(COOKIE_NAME.TOKEN) === oldToken) {
        Cookies.remove(COOKIE_NAME.TOKEN);
        Cookies.remove(COOKIE_NAME.TOKEN, cookieOptions);
      }
    }, 1000);
  }
  /**  老的Token如果有则兼容赋值到 headers.Authorization === END ===稳定后删除 */
  setRenewing(true);
  return axios({
    url: '/gw-api/gateway/token/renew',
    method: 'POST',
    headers,
  })
    .then((res) => {
      const ret = res.data;
      if (ret?.success) {
        const userName = Cookies.get('userName');
        if (userName && userName !== 'undefined') {
          Cookies.set('userName', userName, cookieOptions);
        }
        setLoginInfo(ret.data);
       
        return Promise.resolve(ret.data.accessToken as string);
      } else {
        Sentry.captureMessage('api_token_renew_failed', {
          level: 'error',
          extra: ret,
        });
        // localStorage.setItem('tokenAt', Date.now().toString());
        return Promise.reject('ret not success');
      }
    })
    .catch((err) => {
      if (err !== 'ret not success') {
        Sentry.captureMessage('api_token_renew_failed', {
          level: 'error',
          extra: {
            err,
          },
        });
      }
      return Promise.reject();
    }).finally(() => {
      setRenewing(false);
    });
};

// 失效时间
const EXPIRE_TOKEN_DURATION = 12 * 60 * 60 * 1000;
export const isTimeOut = () => {
  // tokenAt 为token过期时间

  // const tokenAt = localStorage.getItem('tokenAt');
  const tokenAt = Cookies.get(COOKIE_NAME.TOKEN_AT);
  let current: number;

  if (!tokenAt) {
    // 如果没有设置过期时间则认为已经过期 不需要renew
    return false;
  } else {
    current = Number(tokenAt);
  }
  if(Date.now() > current) {
    // tokenAt 注入之间在当前时间之前 -> 说明tokenAt是老的登录版本注入的 -> 那就得用老的逻辑去判断 
    // TODO 后续稳定之后去掉
    if (Date.now() - current < EXPIRE_TOKEN_DURATION) {
      // 当前时间 - 设置时间  小于 12h -> 不去续签
      return false;
    } else {
       // 当前时间 - 设置时间 大于 12h -> 去续签
      return true;
    }
  }
  if ((current - Date.now()) > EXPIRE_TOKEN_DURATION) {
    // 过期时间 - 当前时间 大于 12h -> 不去续签
    return false;
  } else {
    // 小于 12h -> 去续签
    return true;
  }
};
